import color from './colors/classes';
import typography from './typography/classes';
export default {
  color,
  typography
};
//# sourceMappingURL=classes.js.map